/**
 * SurveyLogic
 * This class should handle all client side business logic associated with a survey.
 * This includes, but should not be limited to:
 * 		Client side validation bindings
 * 		Immediate branching rules or actions
 * 		Local (page) branching/piping logic
 *
 * @param {Object} logic
 * 		variables: Array of objects containing at least an 'id' attribute
 */

import * as React from 'react';
import ReactDOM from 'react-dom';
import FileUploadField from 'sma.fs/surveys/form-fields/file-upload/FileUploadField';

import { AjaxFormModal, AjaxFormContent } from 'sma.common/components/modals';
import getComponentWithTheme from '../../themeProvider';

const STRINGS = require('sma.applicant/surveys/strings');

function getVariableQuery(variable) {
	variable = variable.replace(/(:|\.)/g, '\\$1');

	const res = $(
		`#x${variable} input ,`
		+ `#x${variable} select ,`
		+ `#x${variable} textarea ,`
		+ `.x${variable} input ,`
		+ `.x${variable} select, `
		+ `.x${variable} textarea `,
	).not(`#x${variable} .append-to-previous *, .x${variable}.append-to-previous *`);

	return res;
}

function SurveyLogic(config) {
	const that = this;

	if (!config) {
		config = {};
	}
	if (!config.variables) {
		config.variables = [];
	}

	const wordCountValidation = function (ele, variable) {
		let errorMsg = `${WORD_ENTERED}: {count}. `;

		if (variable.validation.minWords) {
			errorMsg += `${MINIMUM}: {min} `;
		}
		if (variable.validation.maxWords) {
			errorMsg += `${MAXIMUM}: {max}`;
		}

		if (variable.validation.errorMsg != gettext('Invalid entry.') && variable.validation.errorMsg) {
			errorMsg = variable.validation.errorMsg;
		}

		const parent = ele.parents('div:first');

		if (!parent.find('.word-count').length) {
			let html = errorMsg.replace('{count}', '<span class="entered"></span>');
			html = html.replace('{min}', '<span class="min"></span>');
			html = html.replace('{max}', '<span class="max"></span>');
			parent.append($('<div class="word-count"/>').html(html));
		}

		parent.find('.word-count .min').text(variable.validation.minWords);
		parent.find('.word-count .max').text(variable.validation.maxWords);
		let val = ele.val();

		val = val.replace(/[\n\r\ ]/gi, ' ');
		val = val.replace(/-/g, ''); // replace with dashes with nothing

		const val_split = val.split(' ');
		let count = 0;

		for (let i = 0; i < val_split.length; i++) {
			if (val_split[i].trim() != '') {
				count++;
			}
		}

		parent.find('.word-count .entered').text(count);
	};

	const characterCountValidation = function (ele, variable) {
		const parent = ele.parents('div:first');
		if (!parent.find('.character-count').length) {
			parent.append($('<span><\/span>', { class: 'character-count' }).html(`<br/>${CHAR_ENTERED}: <span class="entered"></span><br />${MINIMUM}: <span class="min"></span> ${MAXIMUM}: <span class="max"></span>`));
			parent.find('.character-count .min').text(variable.validation.minLength);
			parent.find('.character-count .max').text(variable.validation.maxLength);
		}
		const val = ele.val();

		parent.find('.character-count .entered').text(val.length);
		if (val.length > variable.validation.maxLength || val.length < variable.validation.minLength) {
			parent.find('.character-count').css({ color: 'red' });
		} else {
			parent.find('.character-count').css({ color: 'black' });
		}
	};

	$.each(config.variables, (i, variable) => {
		(function (variable) {
			that[variable.id] = {};
			$.extend(that[variable.id], variable, {
				element: getVariableQuery(variable.id),
			});

			if (variable.validation) {
				// On page load if the textarea has wordCount validation and has a value show some info
				if (variable.validation.type == 'wordCount' && that[variable.id].element.val() != '') {
					wordCountValidation(that[variable.id].element, variable);
				} else if (variable.validation.type == 'all' && that[variable.id].element.val() != '') {
					characterCountValidation(that[variable.id].element, variable);
				}

				variable.validation.regex = variable.validation.regex || '.*';
				that[variable.id].element.bind('keyup mouseup', function (e) {
					if (variable.validation.maxLength && $(this).val().length > variable.validation.maxLength) {
						// $(this).val($(this).val().substr(0, variable.validation.maxLength));
					}

					if (variable.validation.type == 'wordCount') {
						wordCountValidation($(this), variable);
					} else if (variable.validation.type == 'all') {
						characterCountValidation($(this), variable);
					}
				}).blur(function (e) {
					let valid = true;
					if ((new RegExp(variable.validation.regex, 'm')).test($(this).val())) {
						if (variable.validation.maxLength && $(this).val().length > variable.validation.maxLength) {
							// $(this).val($(this).val().substr(0, variable.validation.maxLength));

						}
					} else {
						valid = false;
					}

					if (variable.validation.precision) {
						try {
							if ($(this).val().split('.')[1].length > variable.validation.precision) {
								valid = false;
							}
						} catch (e) {
							// Do nothing
						}
					}
					if (valid) {
						let curVal = $(this).val();
						if ((variable.validation.type == 'postal-ca' && curVal.charAt(3) != ' ') || (variable.validation.type == 'postal' && curVal.length == 6 && curVal.charAt(3) != ' ')) {
							curVal = curVal.replace(/(\S{3})/, '$1 ');
							$(this).val(curVal);
						}
						if (variable.validation.type == 'percentage-bound' || variable.validation.type == 'percentage-unbound') {
							curVal = curVal.replace(/%$/, '');
							$(this).val(curVal);
						}
						if (variable.validation.type == 'currency' | variable.validation.type == 'currency-euro') {
							curVal = curVal.replace(/[^\d.,-]/g, '');
							$(this).val(curVal);
						}
						that[variable.id]._cached_value = curVal;
						$(this).parent().find('.inlineValidationError').remove();
						// $('input[type="submit"]').removeAttr('disabled');
					} else if ($(this).val() === '') {
						// empty string, do nothing
					} else {
						const errorDiv = $(this).parent().find('.inlineValidationError');

						if (errorDiv.length > 0) {
							errorDiv.html(`<li>${$(this).val()} : ${(variable.validation.errorMsg) ? variable.validation.errorMsg : gettext('Invalid entry')}<\/li>`);
						} else {
							$('<ul><\/ul>')
								.addClass('inlineValidationError')
								.addClass('errorlist')
								.append($('<li></li>', {
									text: `${$(this).val()} : ${variable.validation.errorMsg}` ? variable.validation.errorMsg : gettext('Invalid entry'),
								}))
								.insertBefore($(this));
							// $('input[type="submit"]').attr('disabled', 'disabled');
						}
						// $(this).val(that[variable.id]._cached_value || '');
					}
				});
			}
		}(variable));
	});
}

// Enable radio button selection via Enter key press
function enableRadioEnterSelection($formElement) {
	$formElement.find('input[type="radio"]').keydown((e) => {
		let key = e.keyCode || e.which;
		if (key === 13) {
			e.preventDefault();
			$(e.currentTarget).prop('checked', true).trigger('change');
		}
	});
}

/* Must be a global */
const onSurveyLoad = function () {
	$('input[type="submit"]').removeAttr('disabled');

	$('#survey-form').submit((event) => {
		setTimeout(() => {
			$('input[type="submit"]').attr('disabled', 'disabled');
		}, 5);
	});

	/** *************** Ranking ******************** */

	// Enable jQuery UI drag-and-drop on touch devices so ranking questions
	// render the same drag-drop UI on mobile as on desktop, instead of being
	// swapped to a radio-button grid that looks like a rating question.
	if ('ontouchend' in document && $.ui && $.ui.mouse) {
		// Re-applied on every onSurveyLoad so newly rendered page elements get touch-action:none.
		$('.draggable-rank-variable-box, .draggable-rank-variable-box *').css({
			'touch-action': 'none',
			'-webkit-user-select': 'none',
			'user-select': 'none',
			'-webkit-touch-callout': 'none',
		});

		if (!$.ui.mouse.prototype._touchShimApplied) {
		(function ($) {
			const proto = $.ui.mouse.prototype;
			const _mouseInit = proto._mouseInit;
			const _mouseDestroy = proto._mouseDestroy;

			proto._touchShimApplied = true;

			function simulateMouse(e, type) {
				if (e.originalEvent.touches.length > 1) return;
				const touch = e.originalEvent.changedTouches[0];
				const ev = document.createEvent('MouseEvents');
				ev.initMouseEvent(
					type, true, true, window, 1,
					touch.screenX, touch.screenY, touch.clientX, touch.clientY,
					false, false, false, false, 0, null
				);
				e.target.dispatchEvent(ev);
			}

			let _touchActive = false;
			let _touchMoved = false;

			proto._touchStart = function (e) {
				if (!_touchActive && this._mouseCapture(e.originalEvent.changedTouches[0])) {
					_touchActive = true;
					_touchMoved = false;
					simulateMouse(e, 'mouseover');
					simulateMouse(e, 'mousemove');
					simulateMouse(e, 'mousedown');
				}
			};
			proto._touchMove = function (e) {
				if (_touchActive) {
					_touchMoved = true;
					simulateMouse(e, 'mousemove');
				}
			};
			proto._touchEnd = function (e) {
				if (_touchActive) {
					simulateMouse(e, 'mouseup');
					simulateMouse(e, 'mouseout');
					if (!_touchMoved) simulateMouse(e, 'click');
					_touchActive = false;
					_touchMoved = false;
				}
			};
			proto._touchCancel = function (e) {
				if (_touchActive) {
					simulateMouse(e, 'mouseup');
					_touchActive = false;
					_touchMoved = false;
				}
			};
			proto._mouseInit = function () {
				this._touchStartProxy = $.proxy(this, '_touchStart');
				this._touchMoveProxy = $.proxy(this, '_touchMove');
				this._touchEndProxy = $.proxy(this, '_touchEnd');
				this._touchCancelProxy = $.proxy(this, '_touchCancel');
				this.element.bind({
					touchstart: this._touchStartProxy,
					touchmove: this._touchMoveProxy,
					touchend: this._touchEndProxy,
					touchcancel: this._touchCancelProxy,
				});
				_mouseInit.call(this);
			};
			proto._mouseDestroy = function () {
				this.element.unbind({
					touchstart: this._touchStartProxy,
					touchmove: this._touchMoveProxy,
					touchend: this._touchEndProxy,
					touchcancel: this._touchCancelProxy,
				});
				delete this._touchStartProxy;
				delete this._touchMoveProxy;
				delete this._touchEndProxy;
				delete this._touchCancelProxy;
				_mouseDestroy.call(this);
			};
		}(jQuery));
		} // end !_touchShimApplied
	}

	const escapeSelector = function (id) {
		return id.replace(/([\.:])/g, '\\$1');
	};

	$.each($('.ranking-question'), (i, el) => {
		const original = $('.original-question', el);
		$('.original-question input:checked', el).each(function (i) {
			const ids = this.id.split('_');
			const choice_index = ids[3];
			const variable_index = `${ids[1]}_${ids[2]}`;
			const choice_index_span = $('.rank_index', el).filter(function () {
				return $(this).text() == choice_index;
			});
			const choice_div = $(choice_index_span).parent();
			const variable_index_span = $('.variable_index', el).filter(function () {
				return $(this).text() == variable_index;
			});
			const variable_div = $(variable_index_span).parent();
			$(choice_div).children('.droppable-rank-variable-text').hide();
			$(choice_div).append($(variable_div));
			$(variable_div).css({
				position: 'relative',
				top: 0,
				left: 0,
			});
			$(choice_div).data('dragged-item', variable_div);
		});
		// for each variable make a draggable
		$('.draggable-rank-variable-box', el).draggable({
			stack: 'div',
			start(event, ui) {
				$(this).data('OrgPosition', $(this).position());
				$(this).data('parent', $(this).parent());
				$('.droppable-rank-variable-box', el).eq(0).css('margin-top', 35 + $(window).scrollTop() - $('.rank-choice-bin', el).offset().top > 5 ? 35 + $(window).scrollTop() - $('.rank-choice-bin', el).offset().top : 5);
			},
			stop(event, ui) {
				if ($(this).parent()[0] == $(this).data('parent')[0]) {
					$(this).css({
						position: 'absolute',
						top: $(this).data('OrgPosition').top,
						left: $(this).data('OrgPosition').left,
					});
					const relative_position = $(this).offset();
					$(this).css({ position: 'relative' });
					$(this).offset(relative_position);
				}
			},
		});

		// for each choice make it a droppable
		$('.rank-variable-bin', el).droppable({
			accept(dropElem) {
				if ($(dropElem).hasClass('draggable-rank-variable-box')) {
					return true;
				}

				// not a correct droppable element
				return false;
			},
			activeClass: 'ui-state-hover',
			hoverClass: 'ui-state-active',
			drop(event, ui) {
				const parent = $(ui.draggable).parent();
				const id = $('.variable_index', ui.draggable).text();

				if ($(parent).hasClass('droppable-rank-variable-box')) {
					$(parent).data('dragged-item', '');
					$(this).append(ui.draggable);
					$(ui.draggable).css({ position: 'relative', top: 0, left: 0 });
					$(parent).children('.droppable-rank-variable-text').show();

					$(`input[name=${escapeSelector(id)}]`, original).prop('checked', false).trigger('change');
				}
			},
		});
		$('.droppable-rank-variable-box', el).droppable({
			accept(dropElem) {
				if ($(dropElem).hasClass('draggable-rank-variable-box')) {
					return true;
				}

				// not a correct droppable element
				return false;
			},
			activeClass: 'ui-state-hover',
			hoverClass: 'ui-state-active',
			drop(event, ui) {
				const parent = $(ui.draggable).parent();
				const rank = $(this).find('.rank_index').text();
				// this draggable already belonged to a droppable
				if ($(this).data('dragged-item') && $(this).data('dragged-item') != '') {
					// if this had something, swap them...
					if ($(parent).hasClass('droppable-rank-variable-box')) {
						$(`input[value=${rank}]`, original).prop('checked', false).trigger('change');
						$(`input#id_${escapeSelector($('.variable_index', $(this).data('dragged-item')).text())}_${$('.rank_index', parent).text()}`).prop('checked', true).trigger('change');
						parent.data('dragged-item', $(this).data('dragged-item'));
						parent.children('.rank_index, .droppable-rank-variable-text').hide();
						parent.append($(this).data('dragged-item'));
						$(this).data('dragged-item').css({
							position: 'relative',
							top: 0,
							left: 0,
						});
					} else {
						// do a position swap
						$(`input#id_${escapeSelector($('.variable_index', $(this).data('dragged-item')).text())}_${$('.rank_index', this).text()}`).prop('checked', false).trigger('change');
						$('.rank-variable-bin', el).append($(this).data('dragged-item'));
					}
				} else if ($(parent).hasClass('droppable-rank-variable-box')) {
					$(parent).data('dragged-item', '');
					$(parent).children('.droppable-rank-variable-text').show();
				}

				$(`input[value=${rank}]`, original).prop('checked', false).trigger('change');
				$(`input#id_${escapeSelector($('.variable_index', ui.draggable).text())}_${rank}`).prop('checked', true).trigger('change');
				$(this).children('.droppable-rank-variable-text').hide();
				$(this).append(ui.draggable);
				$(ui.draggable).css({ position: 'relative', top: 0, left: 0 });
				$(this).data('dragged-item', ui.draggable);
			},
		});
	});

	/** ************* END Ranking ***************** */

	// Bind signature changes:
	$('.signature').bind('change', (e) => { /* 'e.target' will refer to div with "#signature" */
		let inputField; let data; let
			b30data;

		const $target = $(e.target);

		data = $target.jSignature('getData', 'svgbase64');
		b30data = $target.jSignature('getData', 'base30');

		inputField = $target.nextAll('input').first();

		if (b30data && b30data[1].length > 1) {
			inputField.val(data[1]);
			inputField.removeAttr('disabled');
		} else {
			inputField.val('');
			inputField.attr('disabled', 'disabled');
		}
	});

	setTimeout(() => {
		$(window).resize();
	}, 10);

	function initializeSignature() {
		$('.signaturePad').each((i, el) => {
			if ($(el).children().length === 0) {
				$(el).jSignature({
					height: 200,
					width: $('#survey').width(),
					signatureLine: true,
					'background-color': '#f4f4f4',
				});
				$(el).show().jSignature('reset');
			}
			const $signature = $(el).closest('.question.signature');
			const existing = $signature.find('.pre-existing-signature');
			if (existing.length > 0) {
				$signature.find('input').first().attr('disabled', 'disabled');
				$signature.find('.signaturePad').hide();
			}
		});
	}

	$(document).ready(() => {
		setTimeout(initializeSignature, 100);
		enableRadioEnterSelection($('#survey-form'));
	});

	$('.reset-signature').click((evnt) => {
		const $signature = $(evnt.target).closest('.question.signature');
		const $signaturePad = $signature.find('.signaturePad').first();
		const existing = $signature.find('.pre-existing-signature').remove();
		$signaturePad.jSignature('reset');
		$signature.find('input').first().removeAttr('disabled').val('');
		$signaturePad.show();
	});

	/** *************** SLIDER ******************* */

	// Multiple Choice Slider Appearance
	$.each($('.slider-container'), function (i, el) {
		const slider_info = $('.slider-info', $(this).parent());
		const checked_choice = $('li input:checked', slider_info);

		const num_options = $('li', slider_info).length;
		const header_percentage = 100 / num_options;

		const slider_el = $(el).slider({
			min: 0,
			max: num_options - 1,
			value: checked_choice ? checked_choice.val() : 0,
			create(event, ui) {
				const question_id = $('input[type=text]', $(this).parent()).attr('id');
				$(`label[for="${question_id}"]`).remove();

				// Set slider if valid choice, else fallback to 0th
				if (checked_choice.length > 0) {
					checked_choice.prop('checked', true);
					checked_choice.trigger('change');
				} else {
					$($('li input', slider_info)[0]).prop('checked', true);
				}

				// Build Headers
				const that_parent = $(this).parent();
				const num_headers = $('li', slider_info).length;

				$('li', slider_info).each((i, el) => {
					let text_align = 'center';
					if (i == 0) {
						text_align = 'right';
					} else if (i == num_headers - 1) {
						text_align = 'left';
					}

					const slider_cell = $('<td/>', {
						display: 'inline',
						style: `text-align:${text_align};word-wrap: break-word;`,
						html: $($('li label', slider_info)[i]).html(),
					});
					slider_cell.width(`${header_percentage}%`);

					$('.slider-headers', that_parent).append(slider_cell);
				});
			},
			change(event, ui) {
				const radio_query = $($('li input', $('.slider-info', $(this).parent()))[ui.value]);
				if (radio_query.prop('checked') == false) {
					radio_query.prop('checked', true);
					radio_query.trigger('change');
				}
				const labels = $('.slider-top-labels td', $(this).parent());

				// move the slider manually to halfway through the current label
				let total_left = 0;
				$.each(labels, (i, el) => {
					if (i <= ui.value) {
						const el_width = $(el).outerWidth();
						total_left += el_width;

						if (i == ui.value) {
							total_left -= el_width / 2;
							total_left -= $(ui.handle).outerWidth() / 2;

							$(ui.handle).css('left', total_left);
						}
					}
				});
			},
		});

		const value = slider_el.slider('option', 'value');
		slider_el.slider('option', 'value', value);
	});

	$('.slider-info').hide();
	$('.slider-hide').hide();

	/** ************* END SLIDER ***************** */

	/** ************ FILE UPLOAD FIELD ************** */

	// FR-ONLY: Legacy file upload from FluidReview
	$('div.question.file-upload').each(function () {
		const q = $(this);

		q.find('input.delete[type=checkbox]').bind('click change keydown', function () {
			if ($(this).prop('checked')) {
				q.find('.upload').hide('fast');
				q.find('input[type=file]').val('');
			} else {
				q.find('.upload').show('fast');
			}
		}).trigger('change');
	});

	// New file upload field for Apply (React based)
	$('div.file-upload-field').each(function () {
		const question = $(this);

		const config = $.data(question[0], 'config');
		const reactContainerElement = React.createElement(FileUploadField, {
			...config,
			disabled: false,
		});
		ReactDOM.render(getComponentWithTheme(
			<>
				{reactContainerElement}
			</>,
			window.LOCALE.theme,
		), question[0]);
	});

	/** ********** END FILE UPLOAD FIELD *********** */

	$('#survey div.question fieldset').hide();
	setTimeout(() => {
		$('#survey div.question fieldset').show();
	}, 0);

	$('.matrix.textgridmatrix').each((i, el) => {
		const original = $('.sum-label-hidden', $(el).parent());
		const inputs = $('input[type=text], textarea', el);

		const calcTotal = function () {
			let total = 0;
			inputs.each(function () {
				const matched = $(this).val().replace(/,/g, '').replace(/ /g, '')
					.match(/([^\d])?(\d*(\.\d+)?)/);
				if (matched && matched[0]) {
					const val = parseFloat(matched[2]);
					if (!isNaN(val)) {
						total += val;
					}
				}
			});
			return parseFloat(total.toFixed(12));
		};

		const update = function (e) {
			if (original.html() != null) {
				$('.sum-label', $(el).parent()).html(original.html().replace(/\{x\}/g, $('span.sumtotal', $(el).parent()).html()).replace(/\{y\}/g, calcTotal()).replace(/\{z\}/g, parseFloat($('span.sumtotal', $(el).parent()).html()) - calcTotal()));
			}
		};

		inputs.keyup(update);
		inputs.blur(update);

		update();
	});

	$('.matrix.threedMatrix').each(function () {
		const that = this;
		const columns = $('tbody tr:has(.variable):first td.variable', this).map((i, el) => $(`td:eq(${i})`, $('tbody tr, tfoot tr', that)));
		$.each(columns, function () {
			const that = this;
			const original = $('.sum-label-hidden', this);
			const inputs = $('input[type=text], textarea', this);

			const calcTotal = function () {
				let total = 0;
				inputs.each(function () {
					const matched = $(this).val().replace(/,/g, '').replace(/ /g, '')
						.match(/(-?\d*(\.\d+)?)/);
					if (matched && matched[0]) {
						const val = parseFloat(matched[1]);
						if (!isNaN(val)) {
							total += val;
						}
					}
				});
				return parseFloat(total.toFixed(12));
			};

			const update = function (e) {
				$('.sum-label', that).text(original.text().replace(/\{x\}/g, $('span.sumtotal', that).text()).replace(/\{y\}/g, calcTotal()));
			};

			inputs.keyup(update);
			inputs.blur(update);

			update();
		});
	});

	$('.datetime').each(function () {
		const dateInput = $('input.date', this);
		const timeInput = $('input.time', this);
		const zoneInput = $('select.zone', this);

		let dateFormat = '';
		const altFormat = dateInput.attr('alt');
		const submitFormat = 'yyyy/mm/dd';
		const selectYears = 200;
		const now = dateInput.attr('now') == 'True';

		if (altFormat == 'mm/yy') {
			dateInput.attr('placeholder', 'MM/YYYY');
			return;
		}

		if (altFormat == 'dd/mm') {
			dateInput.attr('placeholder', 'DD/MM');
			return;
		}

		if (window.DATE_FORMAT == '0') {
			dateFormat = 'mmm dd yyyy';
		} else if (window.DATE_FORMAT == '1') {
			dateFormat = 'dd mmm yyyy';
		} else if (window.DATE_FORMAT == '2') {
			dateFormat = 'yyyy mmm dd';
		}

		if (dateInput.val()) {
			// http://amsul.ca/pickadate.js/date/#formats_prefill
			dateInput.data('value', dateInput.val());
		} else if (now) {
			const date = new Date();
			dateInput.data('value', date);
		}

		$(dateInput).pickadate({
			selectMonths: true,
			format: dateFormat,
			formatSubmit: submitFormat,
			hiddenName: true,
			selectYears,
			defaultTime: false,
		});

		const showMeridian = window.TIME_FORMAT != '1';

		$(timeInput).timepicker({
			template: false,
			minuteStep: 1,
			showMeridian,
		});
	});

	$('a.datetime-now').click(function (e) {
		e.preventDefault();

		const now = new Date();
		const $question = $(this).closest('.question');
		const $visibleDate = $question.find('input.date.picker__input');

		if ($visibleDate.length) {
			$visibleDate.pickadate('picker').set('select', now);
		} else {
			$question.find(':input[name$=_date]').val(now.format('yyyy/mm/dd'));
		}
		$question.find(':input[name$=_time]').val(now.format('HH:MM:ss'));
	});

	// Allow clicking a cell to toggle the checkbox or radio button
	$('.group-table-container table, .grouped-table').delegate('td', 'click', function (e) {
		if (!$(e.target).is('input') && $(e.target).find('input:enabled').length == 1) {
			$(this).find('input:enabled').focus().click()
				.change();
		}
	});

	const checkbox_done = [];
	$('input[type="checkbox"]').each(function (e) {
		const that = this;
		const parent = $(that).parents('.question-body');
		if (checkbox_done.indexOf(parent[0]) < 0) {
			checkbox_done.push(parent[0]);
		} else {
			return;
		}

		const exclusives = parent.find('input[type="checkbox"].na-choice');
		const inclusives = parent.find('input[type="checkbox"]:not(.na-choice):not(.check-all)');
		const selectAll = parent.find('input[type="checkbox"].check-all');
		exclusives.unbind('click').bind('click change', function () {
			parent.find('input[type="checkbox"]').not($(this)).prop('checked', false);
			$(this).parent().parent().siblings()
				.find('input[type=text]')
				.val('')
				.trigger('change');
			let current;
			if ($(this).prop('checked') == false) current = 0;
			else current = 1;
			$('.current-checked', parent).text(current);
		});
		selectAll.unbind('click').bind('click change', function () {
			if ($(this).prop('checked')) {
				inclusives.prop('checked', true);
				exclusives.prop('checked', false);
			} else {
				inclusives.prop('checked', false);
			}
			$('.current-checked', parent).text(inclusives.filter(':checked').length);
		});

		const checkSelectAll = function () {
			if (inclusives.filter(':checked').length == inclusives.length) {
				selectAll.prop('checked', 'true');
			} else {
				selectAll.prop('checked', false);
			}
		};
		inclusives.unbind('click').bind('click change', () => {
			let current = 0;
			parent.find('.na-choice').prop('checked', false);
			current = (inclusives.filter(':checked').length);
			$('.current-checked', parent).text(current);
			checkSelectAll();
		});
		checkSelectAll();
		$('.current-checked', parent).text(inclusives.filter(':checked').length);
	});

	$('select.drilldown').hide().each(function () {
		const that = this;
		const name = $(this).attr('name');
		const describedby = $(this).attr('aria-describedby');

		const choices = $('<select>', {
			size: 5,
			class: 'drill-down-selector',
			change() {
				$(that).val($('option:selected', this).val());
			},
		});

		const categories = $('<select>', {
			size: 5,
			class: 'drill-down-selector',
			'aria-describedby': describedby,
			change() {
				choices.empty();
				const group = $('option:selected', this).data('optgroup');
				if (group) {
					group.find('option').clone().appendTo(choices);
					choices.val($(that).val());
					choices.find('option').each(function () {
						$(this).prop('title', $(this).text());
					});
				}
			},
		});

		categories.delegate('option', 'mousedown', function () {
			if ($(this).attr('selected')) {
				$(this).removeAttr('selected');
				choices.empty();
				$(that).val('');
				return false;
			}
			$(this).attr('selected', 'selected');
			categories.trigger('change');
		});

		$('optgroup', this).each(function (i) {
			categories.append($('<option />', {
				val: i,
				text: $(this).attr('label'),
				data: {
					optgroup: $(this),
				},
			}));

			if ($('option:selected', this).length) {
				categories.val(i);
			}
		});
		choices.insertAfter(this);
		categories.insertAfter(this);
		categories.trigger('change');
	});

	// Allow unchecking of radio buttons
	$('input[type="radio"]').each(function () {
		const checked = $(this).is(':checked');
		$(this).data('wasChecked', checked);
	});

	$('input[type="radio"]').click(function (e) {
		if ($(this).data('wasChecked')) {
			$(this).removeAttr('checked');
			$(this).data('wasChecked', false);
		} else {
			$(`input[name="${$(this).attr('name')}"]`).data('wasChecked', false);
			$(this).data('wasChecked', true);
		}
	});

	$('.grouped-error-row').each(function (i) {
		const that = this;
		$('input', this).click((e) => {
			$('.grouped-error-box', that).removeClass('grouped-error-box');
			$(that).removeClass('grouped-error-row');
		});
	});

	$('.grouped-error-row').each(function (i) {
		if ($('input[type="radio"]:checked', this).length > 0) {
			$('input[type="radio"]:checked', this).parent().addClass('grouped-error-box');
			$(this).removeClass('grouped-error-row');
		}
	});

	$('.funique').each(function (i) {
		const that = this;
		$('input', this).click(function (x) {
			const that2 = this;
			$('input', that).each(function (z) {
				if (this.value == that2.value && that2 != this) {
					$(this).removeAttr('checked');
				}
			});
		});
	});

	// disable form submission on enter key in text input fields
	$('input[type="text"]').keypress((e) => {
		if (window.event) var key = window.event.keyCode;
		else var key = e.which;	// for firefox
		if (key == 13) e.preventDefault();
	});

	$('input[type="reset"]').click((e) => {
		e.preventDefault();
		$('input[type="text"]').val('');
		$('textarea').val('');
		$('input[type="radio"]').removeAttr('checked');
		$('input[type="checkbox"]').removeAttr('checked');
		$('option').attr('selected', '');
	});

	$('input[name="exit"]').click((e) => {
		if (!confirm(gettext('Are you sure you wish to exit this survey? Any responses you have provided will be discarded.'))) {
			e.preventDefault();
		} else if ($('input[name="_terminated_redirect"]').length > 0) {
			if ($('input[name="_terminated_redirect"]')[0].value) {
				e.preventDefault();
				window.location = $('input[name="_terminated_redirect"]')[0].value;
			}
		}
	});

	// Choice clearing

	$('.surveys-clear-choice').each(function (i, el) {
		const btn = $(this);
		if ($(this).parents('tr').length > 0) {
			var question = $(this).parents('tr:first');
		} else {
			var question = $(this).parents('.question:first');
		}
		const selects = $('input[type="radio"]', question);

		btn.hide();

		btn.click((e) => {
			e.preventDefault();
			selects.prop('checked', false);
			selects.trigger('change');
			btn.hide();
		});

		selects.change((e) => {
			btn.show();
		});

		if (selects.is(':checked')) {
			btn.show();
		}
	});

	/** ******** Dynamic grid client side script ******** */

	$('input.grid-select-all').click(function () {
		const scope = $(this).parents('tr:first');
		if ($(this).prop('checked')) {
			$('input[type="checkbox"]:not(.grid-select-all)', scope).prop('checked', true)
				.each(function () {
					$(this).trigger('change');
				});
		} else {
			$('input[type="checkbox"]:not(.grid-select-all)', scope).prop('checked', false)
				.each(function () {
					$(this).trigger('change');
				});
		}
	});

	$('.dynamic-grid-question')
		.find('input[type="checkbox"]:not(.grid-select-all)')
		.bind('click', function () {
			if (!$(this).prop('checked')) {
				$('.grid-select-all:checked', $(this).parents('tr:first')).prop('checked', false);
			}
		});

	/** ************************************************* */

	/** ************ Branching Info JS ****************** */
	const branchingInfo = $('#survey div.branching-info');
	// If this runs they have JS so use the JS Suited class
	branchingInfo.removeClass('branching-info');
	branchingInfo.addClass('branching-info-js');

	const branchUl = $('span:first', branchingInfo).hide();
	const branchingInfoToggler = $('<div>').prependTo(branchingInfo);
	branchingInfoToggler.append($(`<a href="#" title="${gettext('Toggle Branching Info')}">`).click(function (e) {
		e.preventDefault();
		if (branchUl.is(':visible')) {
			branchUl.slideUp();
			$(this).removeClass('open');
		} else {
			branchUl.slideDown();
			$(this).addClass('open');
		}
	}).html('<img src="/media/img/icons/page_skip.png" />'));
	/** ************************************************* */

	$('input.other').keyup(function (event) {
		if (event.keyCode != '9') {
			$(this).parents('li:first')
				.find('input[type="radio"]')
				.prop('checked', true)
				.trigger('change');

			if (typeof AUTOSELECT_CHECKBOXES !== 'undefined' && AUTOSELECT_CHECKBOXES) {
				$(this).parents('li:first')
					.find('input[type="checkbox"]')
					.prop('checked', true)
					.trigger('change')
					.end()
					.siblings()
					.find('input[type="checkbox"].na-choice')
					.prop('checked', false);
				// .trigger('change');
			}
		}
	});
};

module.exports = {
	SurveyLogic,
	onSurveyLoad,
	getVariableQuery,
};

$(document).ready(onSurveyLoad);
